<template>
    <div class="container">
        <label for="login">Login</label>
        <input type="text" name="login" class="form-control" v-model="login">
        <label for="password">Password</label>
        <input type="password" name="password" class="form-control" v-model="password">
        <div>
            <button class="btn btn-info" @click="enter">enter</button>
        </div>
    </div>
</template>

<script>
import Data from '../API';
export default {
    data() {
        return {
            login: '',
            password: ''
        }
    },
    methods: {
        enter() {
            console.log('click')
            if (this.login !== '' && this.password !== '') {
                Data.logIn({
                    admin: this.login,
                    password: this.password
                })
                .then(json => {
                    if (json.data.status === 'done') {
                        localStorage.setItem('token', json.data.data);
                        this.$router.push('/admin-page')
                    }
                })
                .catch(err => {
                    console.log(err)
                })
            }
        }
    }
}
</script>

<style scoped>
    div {
        padding-top: 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue